 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","404~about~blog-detail~blog-index~calculator~cv~cv-landing~event-detail~event-index~extra~finish-sign~98ec7b3d":"404~about~blog-detail~blog-index~calculator~cv~cv-landing~event-detail~event-index~extra~finish-sign~98ec7b3d","404~about~blog-detail~blog-index~calculator~cv-landing~event-detail~event-index~extra~finish-signup~~3a9e25fc":"404~about~blog-detail~blog-index~calculator~cv-landing~event-detail~event-index~extra~finish-signup~~3a9e25fc","about":"about","blog-detail":"blog-detail","blog-index":"blog-index","calculator":"calculator","cv-landing":"cv-landing","cv~event-detail":"cv~event-detail","event-detail":"event-detail","event-index":"event-index","extra~finish-signup~newsletter~newsletter-mobile~profile~profile-my-cv~project-detail~questionaire~r~2d7b7567":"extra~finish-signup~newsletter~newsletter-mobile~profile~profile-my-cv~project-detail~questionaire~r~2d7b7567","extra~finish-signup~newsletter~profile-my-cv":"extra~finish-signup~newsletter~profile-my-cv","extra":"extra","finish-signup":"finish-signup","newsletter":"newsletter","profile-my-cv":"profile-my-cv","newsletter-mobile":"newsletter-mobile","profile~profile-added":"profile~profile-added","profile":"profile","project-detail":"project-detail","questionaire":"questionaire","referral-form":"referral-form","home":"home","koderia-about":"koderia-about","newsfeed-detail":"newsfeed-detail","newsfeed-index":"newsfeed-index","profile-saved":"profile-saved","project-index":"project-index","promo-index":"promo-index","referral-index":"referral-index","terms-and-conditions":"terms-and-conditions","unsubscribe-index":"unsubscribe-index","work-comparison":"work-comparison","cv":"cv","profile-added":"profile-added","auth-forgot-password":"auth-forgot-password","auth-sign-in~auth-sign-up":"auth-sign-in~auth-sign-up","auth-sign-in":"auth-sign-in","auth-sign-up":"auth-sign-up","referral-approval":"referral-approval"}[chunkId]||chunkId) + "." + {"404":"d6e8d7a2","404~about~blog-detail~blog-index~calculator~cv~cv-landing~event-detail~event-index~extra~finish-sign~98ec7b3d":"8ba03206","404~about~blog-detail~blog-index~calculator~cv-landing~event-detail~event-index~extra~finish-signup~~3a9e25fc":"1f3fd01a","about":"29992ab8","blog-detail":"2be42c29","blog-index":"423ec1bd","calculator":"42ee9edf","cv-landing":"4c95399f","cv~event-detail":"81a67aeb","event-detail":"f1a1c304","event-index":"91f0ad5d","extra~finish-signup~newsletter~newsletter-mobile~profile~profile-my-cv~project-detail~questionaire~r~2d7b7567":"5c792491","extra~finish-signup~newsletter~profile-my-cv":"a4a8d7ed","extra":"9d935b23","finish-signup":"9840bd4c","newsletter":"3f34d773","profile-my-cv":"b96cdfc8","newsletter-mobile":"14cabbdf","profile~profile-added":"a59f9e8c","profile":"63b461a5","project-detail":"754b9328","questionaire":"1a5a0f88","referral-form":"93ca316d","home":"d2c384fb","koderia-about":"c2a59cbc","newsfeed-detail":"c26129d7","newsfeed-index":"e6b908a7","profile-saved":"3bd7be83","project-index":"1ecb74f5","promo-index":"871f7843","referral-index":"f16f381d","terms-and-conditions":"68305eea","unsubscribe-index":"fd495de9","work-comparison":"a29a886c","cv":"271ab5c5","profile-added":"26cd4491","auth-forgot-password":"32998beb","auth-sign-in~auth-sign-up":"3bab0f0b","auth-sign-in":"94445c3d","auth-sign-up":"47eb1cfd","chunk-2d0cf4fe":"59e7c04a","chunk-2d0d0639":"ceff4d2d","chunk-2d21ab77":"ebd2ae7a","referral-approval":"b6ab0059"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"404~about~blog-detail~blog-index~calculator~cv~cv-landing~event-detail~event-index~extra~finish-sign~98ec7b3d":1,"404~about~blog-detail~blog-index~calculator~cv-landing~event-detail~event-index~extra~finish-signup~~3a9e25fc":1,"about":1,"blog-detail":1,"blog-index":1,"calculator":1,"cv-landing":1,"event-detail":1,"extra~finish-signup~newsletter~newsletter-mobile~profile~profile-my-cv~project-detail~questionaire~r~2d7b7567":1,"extra~finish-signup~newsletter~profile-my-cv":1,"extra":1,"finish-signup":1,"newsletter":1,"profile-my-cv":1,"newsletter-mobile":1,"profile~profile-added":1,"profile":1,"project-detail":1,"questionaire":1,"referral-form":1,"home":1,"profile-saved":1,"project-index":1,"promo-index":1,"terms-and-conditions":1,"unsubscribe-index":1,"work-comparison":1,"cv":1,"profile-added":1,"auth-forgot-password":1,"auth-sign-in~auth-sign-up":1,"auth-sign-in":1,"auth-sign-up":1,"referral-approval":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","404~about~blog-detail~blog-index~calculator~cv~cv-landing~event-detail~event-index~extra~finish-sign~98ec7b3d":"404~about~blog-detail~blog-index~calculator~cv~cv-landing~event-detail~event-index~extra~finish-sign~98ec7b3d","404~about~blog-detail~blog-index~calculator~cv-landing~event-detail~event-index~extra~finish-signup~~3a9e25fc":"404~about~blog-detail~blog-index~calculator~cv-landing~event-detail~event-index~extra~finish-signup~~3a9e25fc","about":"about","blog-detail":"blog-detail","blog-index":"blog-index","calculator":"calculator","cv-landing":"cv-landing","cv~event-detail":"cv~event-detail","event-detail":"event-detail","event-index":"event-index","extra~finish-signup~newsletter~newsletter-mobile~profile~profile-my-cv~project-detail~questionaire~r~2d7b7567":"extra~finish-signup~newsletter~newsletter-mobile~profile~profile-my-cv~project-detail~questionaire~r~2d7b7567","extra~finish-signup~newsletter~profile-my-cv":"extra~finish-signup~newsletter~profile-my-cv","extra":"extra","finish-signup":"finish-signup","newsletter":"newsletter","profile-my-cv":"profile-my-cv","newsletter-mobile":"newsletter-mobile","profile~profile-added":"profile~profile-added","profile":"profile","project-detail":"project-detail","questionaire":"questionaire","referral-form":"referral-form","home":"home","koderia-about":"koderia-about","newsfeed-detail":"newsfeed-detail","newsfeed-index":"newsfeed-index","profile-saved":"profile-saved","project-index":"project-index","promo-index":"promo-index","referral-index":"referral-index","terms-and-conditions":"terms-and-conditions","unsubscribe-index":"unsubscribe-index","work-comparison":"work-comparison","cv":"cv","profile-added":"profile-added","auth-forgot-password":"auth-forgot-password","auth-sign-in~auth-sign-up":"auth-sign-in~auth-sign-up","auth-sign-in":"auth-sign-in","auth-sign-up":"auth-sign-up","referral-approval":"referral-approval"}[chunkId]||chunkId) + "." + {"404":"574a77ba","404~about~blog-detail~blog-index~calculator~cv~cv-landing~event-detail~event-index~extra~finish-sign~98ec7b3d":"9e52d085","404~about~blog-detail~blog-index~calculator~cv-landing~event-detail~event-index~extra~finish-signup~~3a9e25fc":"2fb67d3e","about":"32bce01f","blog-detail":"5ce1994e","blog-index":"6378cfd3","calculator":"b71212b4","cv-landing":"4a683153","cv~event-detail":"31d6cfe0","event-detail":"ee6f04ae","event-index":"31d6cfe0","extra~finish-signup~newsletter~newsletter-mobile~profile~profile-my-cv~project-detail~questionaire~r~2d7b7567":"f17219af","extra~finish-signup~newsletter~profile-my-cv":"007bce02","extra":"900bfb02","finish-signup":"66c8443d","newsletter":"06f6e420","profile-my-cv":"a27c3c07","newsletter-mobile":"8b28839a","profile~profile-added":"aa5a28c0","profile":"10de15bb","project-detail":"92eedc94","questionaire":"a2b7a7a5","referral-form":"3d9cb5aa","home":"f00fd7df","koderia-about":"31d6cfe0","newsfeed-detail":"31d6cfe0","newsfeed-index":"31d6cfe0","profile-saved":"90c3314a","project-index":"4fd3e4dc","promo-index":"1ebc6476","referral-index":"31d6cfe0","terms-and-conditions":"1f9a07ce","unsubscribe-index":"2c92c34e","work-comparison":"7bd41af9","cv":"37986f2f","profile-added":"6a5b24fe","auth-forgot-password":"2a657c60","auth-sign-in~auth-sign-up":"a24128be","auth-sign-in":"fe653952","auth-sign-up":"5a7ae4ca","chunk-2d0cf4fe":"31d6cfe0","chunk-2d0d0639":"31d6cfe0","chunk-2d21ab77":"31d6cfe0","referral-approval":"b3a957c0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
